import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon, StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  quote: "Llevaba años jugando 'más o menos'. Con el Tomo 2 entendí por qué siempre perdía el Envido. Ahora sé exactamente cuándo cantar y cuándo cortar.",
  name: 'Martín R.',
  profile: 'Jugador de asado, 34 años',
  location: 'Buenos Aires'
}, {
  quote: 'El Tomo 3 me cambió la cabeza. Siempre creí que mentir en el Truco era suerte. Ahora es un sistema. Gané 4 partidas seguidas en el asado familiar y nadie entendió qué pasó.',
  name: 'Gustavo P.',
  profile: 'Jugador de juntada, 41 años',
  location: 'Córdoba'
}, {
  quote: 'Jugaba en pareja con mi hermano hace 10 años y nunca nos coordinamos bien. Con el Tomo 4 armamos un sistema de señas en una tarde. La próxima partida ganamos sin problema.',
  name: 'Luciana M.',
  profile: 'Jugadora de club, 28 años',
  location: 'Rosario'
}, {
  quote: 'Fui a mi primer torneo de club con el Tomo 6 fresco. Llegué a semifinales. Nunca había pasado de primera ronda.',
  name: 'Diego S.',
  profile: 'Jugador de torneo, 52 años',
  location: 'Mendoza'
}, {
  quote: 'Lo que más me sorprendió fue el Tomo 5. Empecé a leer a mis rivales en las primeras 3 manos. Mi cuñado, que me ganaba siempre, no entendió qué le pasó.',
  name: 'Romina T.',
  profile: 'Jugadora de asado, 38 años',
  location: 'Tucumán'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-truco-dark relative" data-id="element-238">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
        <div className="text-center mb-16" data-id="element-240">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-truco-cream mb-4" data-id="element-241">
            LO QUE DICEN LOS QUE YA LO USARON
          </h2>
          <div className="flex justify-center gap-1" data-id="element-242">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-truco-gold fill-current" data-id="element-243" />)}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-244">
          {TESTIMONIALS.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-truco-surface border border-truco-gold/10 p-6 rounded-xl flex flex-col" data-id="element-245">
              <QuoteIcon className="w-8 h-8 text-truco-gold/30 mb-4" data-id="element-246" />
              <p className="text-truco-creamMuted italic mb-6 flex-grow" data-id="element-247">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-truco-gold/10 pt-4 mt-auto" data-id="element-248">
                <p className="font-bold text-truco-cream" data-id="element-249">{testimonial.name}</p>
                <p className="text-sm text-truco-gold" data-id="element-250">{testimonial.profile}</p>
                <p className="text-xs text-truco-creamMuted/60" data-id="element-251">
                  {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}